export default __webpack_public_path__ + "static/media/instance.005422bf.png";